// removed by extract-text-webpack-plugin
module.exports = {"paginationPanel":"paginationPanel__3tjjh","changeSizeOuterWrapper":"changeSizeOuterWrapper__2WZOd","button":"button__3sq_Q","leftButton":"leftButton__2g9-a","rightButton":"rightButton__1n5pM","pagainationWrapper":"pagainationWrapper__3jyPy","changeSizeWrapper":"changeSizeWrapper__3NESZ","pageSize":"pageSize__emlNU","pagination":"pagination__3eVlq","innerClass":"innerClass__3k-20","itemClass":"itemClass__1MNtn","linkClass":"linkClass__3me9Z","activeLinkClass":"activeLinkClass__10BMV"};


//////////////////
// WEBPACK FOOTER
// ./components/paginationPanelSearch/style.scss
// module id = GlOr
// module chunks = 17